import type {ReactNode} from 'react';
import Link from 'next/link';
import {trackAttrs} from '@/lib/analytics';

type Variant = 'primary' | 'secondary' | 'light' | 'outline-light';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-brand-700 text-white hover:bg-brand-800 hover:text-white shadow-sm', // 5.1:1 contrast (WCAG AA)
  secondary: 'bg-white text-zinc-900 ring-1 ring-zinc-300 ring-inset hover:bg-zinc-50 hover:text-zinc-900',
  light: 'bg-white text-zinc-900 hover:bg-brand-50 hover:text-zinc-900 shadow-sm',
  'outline-light': 'text-white ring-1 ring-white/60 ring-inset hover:bg-white/10 hover:text-white',
};

export const buttonClass = (variant: Variant = 'primary') =>
  `inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold no-underline transition-colors ${VARIANTS[variant]}`;

/** Link styled as a button. */
type ButtonLinkProps = {
  href: string;
  children: ReactNode;
  variant?: Variant;
  /** Tracks a `cta_click` event (GA4). */
  track?: {cta: string; location: string};
};

export const ButtonLink = ({href, children, variant = 'primary', track}: ButtonLinkProps) => (
  <Link href={href} className={buttonClass(variant)} {...(track ? trackAttrs('cta_click', track) : {})}>
    {children}
  </Link>
);
